export interface ServerErrorBody {
  errorCode?: string;
  code?: string;
  reason?: string;
  message?: string;
}

export interface ServerErrorResponse {
  status?: number;
  statusText?: string;
  error?: ServerErrorBody | string;
}

const STRING_TYPE = 'string';

export function hasServerErrorCode(error: ServerErrorResponse, code: string): boolean {
  if (!error) { return false; }
  const body = serverErrorBody(error.error);
  return [body.errorCode, body.code, body.reason, body.message, error.statusText, error.error]
    .some(candidate => candidate === code);
}

function serverErrorBody(body: ServerErrorBody | string): ServerErrorBody {
  if (typeof body !== STRING_TYPE) { return body as ServerErrorBody || {}; }
  try { return JSON.parse(body as string) || {}; } catch (error) { return {}; }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/server-error-code.ts